// extracted by mini-css-extract-plugin
export default {"wrapper":"Gv2d8M","ols_vets":"X5trMA","olsVets":"X5trMA","container":"fkm2bA","picture":"lycCPr","cta":"v8Kbsz","overlay":"gHCf9j"};